import { Stack, Typography } from "@mui/material";
import useLocales from "src/hooks/useLocales";
import useResponsive from "src/hooks/useResponsive";

import ShowTypeToggle from "./components/ShowTypeToggle";

// ----------------------------------------------------------------------

export const ResultsHeader = () => {
	const isMobile = useResponsive("down", "sm");
	const { translate } = useLocales();
	return (
		<Stack
			sx={{
				mb: 2,
				flexDirection: "row",
				justifyContent: "space-between",
				px: 3,
				alignItems: "center"
			}}
		>
			{!isMobile && (
				<Typography variant='h6'>{translate("result_demo.active_positions")}</Typography>
			)}
			<ShowTypeToggle />
		</Stack>
	);
};

export default ResultsHeader;
